import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//expense
const ExpenseCategory = Loadable(lazy(() => import("pages/expense/Category")));
const AddExpense = Loadable(lazy(() => import("pages/expense/Add")));
const ExpenseReceipt = Loadable(lazy(() => import("pages/expense/Receipt")));
const Expense = Loadable(lazy(() => import("pages/expense")));
const ExpenseCategoryReport = Loadable(lazy(() => import("pages/expense/CategoryReport")));

const ExpenseRoutes = {
  path: "expense",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "category",
      element: <ExpenseCategory />,
    },
    {
      path: "add",
      element: <AddExpense />,
    },
    {
      path: "receipt/:expenseId",
      element: <ExpenseReceipt />,
    },
    {
      path: "list",
      element: <Expense />,
    },
    {
      path: "report-category",
      element: <ExpenseCategoryReport />,
    },
  ],
};

export default ExpenseRoutes;
